import { render, staticRenderFns } from "./fundind-wallet.vue?vue&type=template&id=18933fe9&scoped=true"
import script from "./fundind-wallet.vue?vue&type=script&lang=js"
export * from "./fundind-wallet.vue?vue&type=script&lang=js"
import style0 from "./fundind-wallet.vue?vue&type=style&index=0&id=18933fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18933fe9",
  null
  
)

export default component.exports